/*jshint loopfunc: true */
define('editor/edit/layers/add/directions/index',['durandal/app', 'plugins/dialog', 'plugins/http', 'knockout', 'knockout-mapping', 'jquery'], function (app, dialog, http, ko, komapping, $) {
    var viewmodel = function() {
        var self = this;

        self.mapId = null;
        self.content = ko.observable('');
        self.calculatingRoute = ko.observable(false);

        var calculatingMessage = new dialog.MessageBox('Calculating Route','Please Wait',["Close"]);
        self.locations = [];
        self.blankLocation = {
            input: "",
            matches: [],
            disambiguated: null
        };
        self.locations.push($.extend({}, self.blankLocation)); // start
        self.locations.push($.extend({}, self.blankLocation)); // end
        // "via" waypoints added by pushing additional items
        
        self.travelModes = ['pedestrian', 'driving'];
        self.selectedTravelMode = ko.observable('driving');
        self.inputToPopulateMapClickLocation = null; 

        self.activate = function(mapId, cancelFunc) {
            self.mapId = mapId;
            self.cancel = cancelFunc;

            self.composeWaypointsView();
        };

        self.composeWaypointsView = function() {
            self.content({ view: 'editor/edit/layers/add/directions/waypoints.html' });
            app.trigger('directions:composing');
        };

        self.composeDisambiguationView = function() {
            self.content({ view: 'editor/edit/layers/add/directions/disambiguation.html' });
        };

        self.returnToList = function () {
            app.trigger('directions:complete');
            self.cancel();
        };

        self.cancelDisambiguate = function () {
            self.composeWaypointsView();
        };

        self.addWaypoint = function () {
            var waypointsContainer = $('#waypoints'),
                template = $('<div class="form-inline">' +
                    '<div class="form-group">' +
                    '<label>Via</label>' +
                    '<br/>' +
                    '<input data-rel="waypoint" type="text" class="form-control waypoint" placeholder="Via" />' +
                    '<button class="btn" data-bind="click: activateWaypointTarget" data-rel="waypoint">' +
                    '<span class="fa fa-bullseye"></span>' +
                    '</button>' +
                    '</div>' +
                    '</div>' +
                    '<br/>'), 
                newLocation = $.extend({}, self.blankLocation);

            self.locations.splice(self.locations.length - 1, 0, newLocation);

            template.appendTo(waypointsContainer);

            ko.applyBindings(self, template[0]);
        };

        self.activateWaypointTarget = function (ev, el) {
            $('svg').hide(); //polygons etc. prevent clicks below them
            self.inputToPopulateMapClickLocation = $(el.target).closest('div')
                .find("input");

            app.trigger('map:clicks:listen');

            app.on('map:click', function (e) {
                app.trigger('map:clicks:ignore');

                // geo-code lat lng and populate input with proper name
                self.geocodeLocation(e.latlng.lat + ',' + e.latlng.lng)
                    .then(function (response) {
                        $('svg').show();
                        app.off('map:click'); // unsubscribe from events first to avoid unexpected behaviour if something errors below
                        
                        if (!self.inputToPopulateMapClickLocation) {
                            return false;
                        }

                        if (!response || !response.data || response.data.locations.matches.length === 0) {
                            self.inputToPopulateMapClickLocation = null;
                            return app.showMessage("Failed to find a place for the location, please try again", "Geocode failed");
                        }

                    var location = response.data.locations.matches[0],
                        name = location.displayName,
                        idx = $('input.waypoint').index(self.inputToPopulateMapClickLocation),
                        locRef = self.locations[idx];

                    // use the lat lng from the leaflet map click (not result of geocoding)
                    location.latLng = {
                        lat: response.data.locations.searchedLocation.split(",")[0],
                        lng: response.data.locations.searchedLocation.split(",")[1]
                    };

                    locRef.input = name;
                        locRef.matches = [];
                        locRef.disambiguated = location;
                        
                        self.inputToPopulateMapClickLocation.val(name);
                        self.inputToPopulateMapClickLocation = null;
                    }).fail(app.showError);
            });
        };

        self.plan = function () {
            var locations = [],
                needsDisambiguating;

            $('input.waypoint').each(function (index, el) {
                var name = $(el).val();
                locations.push(name);
                self.locations[index].input = name;
            });

            var requiresGeocoding = ko.utils.arrayFilter(self.locations, function (location) {
                return !location.disambiguated;
            });

            var requiresGeocodingFlattened = ko.utils.arrayMap(requiresGeocoding, function (location) {
                return location.input;
            });

            self.geocodeBulkLocations(requiresGeocodingFlattened)
                .then(function (response) {
                    if (!response.success) {
                        return app.showMessage("Unable to find one or more of the specified locations", "Couldn't find location");
                    }
                    
                    self.parseGeocodedLocations(response);
                    needsDisambiguating = response.data.results.disambiguationNeeded;
                    
                    if (response.data.results.disambiguationNeeded) {
                        self.composeDisambiguationView();
                    } else {
                        self.fetchRoute().then(function (response) {
                            dialog.close(calculatingMessage);
                            
                            if (!response.success) {
                                self.calculatingRoute(false);
                                
                                return app.showMessage(response.error);
                            } else {
                                self.cancel();
                                app.trigger('directions:complete');
                            }
                        });
                    }
                })
                .fail(app.showError);
        };
        
        self.geocodeLocation = function (location) {
            var url = "/api/geo/location",
                data = {
                    location: location
                };
 
            return http.post(url, data);
        };

        self.geocodeBulkLocations = function (locations) {
            var url = '/api/geo/locations',
                data = {
                    locations: locations
                };

            return http.post(url, data);
        };

        self.parseGeocodedLocations = function (response) {
            var geocodedLocations = response.data.results.locations,
                geocodedLocationsLen = geocodedLocations.length;

            for (var i = 0; i < geocodedLocationsLen; i++) {
                var geocoded = geocodedLocations[i];
                var waypoint = ko.utils.arrayFirst(self.locations, function (location) {
                    return location.input === geocoded.searchedLocation && !location.matches.length;
                });

                waypoint.matches = geocoded.matches;
            }
        };

        self.planDisambiguated = function () {
            var selectedRadios = $('input[name^=disambiguation_]:checked');

            selectedRadios.each(function (i, el) {
                var indicies = el.value.split('|'),
                    locationsIdx = indicies[0],
                    matchIndex = indicies[1],
                    chosenMatch = self.locations[locationsIdx].matches[matchIndex];

                self.locations[locationsIdx].disambiguated = chosenMatch;
            });

            self.fetchRoute().then(function() {
                dialog.close(calculatingMessage);
                self.cancel();
            });
        };

        self.fetchRoute = function () {
            dialog.show(calculatingMessage);
            var url = "/api/geo/directions",
                locationsLen = self.locations.length,
                params = {
                    editorMapId: self.mapId,
                    waypoints: [],
                    travelMode: self.selectedTravelMode()
                };

            self.calculatingRoute(true);
            
            app.trigger('directions:route:new');


            for (var j = 0; j < locationsLen; j++) {
                params.waypoints.push(self.locations[j].disambiguated);
            }

            return http.post(url, params);
        };
    };

    return viewmodel;
});

